export default __webpack_public_path__ + "static/media/competitions_icon.f472f328.svg";